import {ref} from "vue";

export const useGetCargoManifests = () => {
    const items = ref(null);

    const getCargoManifests = async (updateShipmentId) => {
        let url = '/shipments/cargo-manifests/' + updateShipmentId;

        return await axios.get(url).then(({data}) => {
            items.value = data;
            return data;
        });
    }

    return { getCargoManifests, items };
}
